export default __webpack_public_path__ + "static/media/annoying-sex-map.40d45f33.png";